import React, { useState, useEffect } from 'react'

import baseUrl from '../../../config/baseUrl'
import {
  AppBar,
  Box,
  Typography,
  Button,
  Dialog,
  // Divider,
  // ListItemText,
  // ListItemButton,
  // List,
  IconButton,
  Slide,
  useMediaQuery,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { useNavigate } from 'react-router-dom'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />
})

function index() {
  const [terms, setTerms] = useState('')
  const [privacy, setPrivacy] = useState('')
  const [open, setOpen] = useState(false)
  const [openPrivacyPolicy, setOpenPrivacyPolicy] = useState(false)
  const navigate = useNavigate()
  const isMobile = useMediaQuery('(max-width: 600px)')

  // const fullScreen = useMediaQuery(theme.breakpoints.down('md'))
  const [selectedButton, setSelectedButton] = useState(null)

  const getTerms = async () => {
    const res = await fetch(
      `${baseUrl}/api/file/readpdf/2` || `https://lawttorney.ai/api/file/readpdf/2`,
    )
    const data = await res.json()

    setTerms(data)
  }

  const getPrivacy = async () => {
    const res = await fetch(
      `${baseUrl}/api/fileprivacy/readpdf/1` || `https://lawttorney.ai/api/fileprivacy/readpdf/1`,
    )
    const data = await res.json()

    setPrivacy(data)
  }

  useEffect(() => {
    document.title = 'Terms & Conditions - Lawttorney'
    getTerms()
    setOpen(true)
  }, [])

  const handleClickOpen = () => {
    setSelectedButton(1)
    setOpenPrivacyPolicy(true)
    getPrivacy()
  }

  const handleClose = () => {
    setOpen(false)

    navigate('/auth/register')
  }

  const handleClosePrivacy = () => {
    setOpenPrivacyPolicy(false)
    navigate('/auth/privacy-terms')
  }
  const renderFormattedText = (text) => {
    const initialText = text

    return (
      <div>
        <div
          style={{ textAlign: 'justify', whiteSpace: 'pre-line', padding: '20px' }}
          dangerouslySetInnerHTML={{ __html: initialText }}
        />
      </div>
    )
  }

  return (
    <>
      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        <AppBar sx={{ position: 'relative', p: 0 }}>
          <Box display='flex' justifyContent='space-between'>
            <Typography sx={{ ml: 2, flex: 1, p: '0.5rem ' }} variant='h6' component='div'>
              Terms, Conditions & Privacy policy
            </Typography>
            <IconButton sx={{ p: 0 }} color='inherit' onClick={handleClose} aria-label='close'>
              <CloseIcon sx={{ color: 'black', mr: 1 }} />
            </IconButton>
          </Box>
        </AppBar>

        <Box sx={{ mt: 1, pr: 2, display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
          <Button
            variant='contained'
            onClick={() => {
              alert('Fair Usage Policy coming soon!')
            }}
            sx={{
              py: '0.5rem',
              whiteSpace: 'nowrap', // 👈 prevents text from wrapping
              textTransform: 'none', // optional: keeps original casing
            }}
          >
            Fair Usage Policy
          </Button>

          <Button
            variant='contained'
            className={selectedButton ? '' : ''}
            onClick={handleClickOpen}
            sx={{ py: '0.5rem' }}
          >
            Privacy Policy
          </Button>

          <Button
            variant='contained'
            className={selectedButton ? '' : ''}
            onClick={() => navigate('/auth/register')}
            sx={{ py: '0.5rem' }}
          >
            Back
          </Button>
        </Box>

        <hr />
        <Box
          sx={{
            px: isMobile ? 2 : 20,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <div>{renderFormattedText(terms?.data)}</div>
        </Box>
      </Dialog>

      {/* ------------------------------ Privacy Policy ----------------------- */}

      <Dialog
        fullScreen
        open={openPrivacyPolicy}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Typography sx={{ ml: 2, flex: 1 }} variant='h6' component='div'>
              Privacy Policy
            </Typography>

            <IconButton
              edge='start'
              color='inherit'
              onClick={handleClosePrivacy}
              aria-label='close'
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </AppBar>
        <Typography sx={{ textAlign: 'justify', whiteSpace: 'pre-line', padding: '20px' }}>
          {privacy && privacy?.data}
        </Typography>
      </Dialog>
    </>
  )
}

export default index
